export default "__VITE_ASSET__CYVYUps6__"